import type { Socket } from "socket.io-client";

const requestSocketAcknowledgement = <Result>(
    socket: Socket,
    emit: (acknowledge: (result: Result) => void) => void,
): Promise<Result | null> => {
    return new Promise((resolve) => {
        const connectionId = socket.id;
        let settled = false;

        const settle = (result: Result | null) => {
            if(settled) {
                return;
            }

            settled = true;
            socket.off("disconnect", onDisconnect);
            resolve(result);
        };

        const onDisconnect = () => settle(null);

        socket.once("disconnect", onDisconnect);
        emit((result) => {
            if(!socket.connected || socket.id !== connectionId) {
                settle(null);
                return;
            }

            settle(result);
        });
    });
};

export default requestSocketAcknowledgement;
